<template>
  <div>
    <div class="careful">
      <h2><span>—</span>呼救方法<span>—</span></h2>
      <div class="process">
        <div v-if="dataId == 5" style="color: #666666; margin-bottom: 1vw">
          当您发生清单中所列举的受保障情形时，可以通过以下两种方式与我们联系：
        </div>

        <div class="serviceList" v-if="dataId == 5">
          <ul v-for="(item, index) in housekeeper.list" :key="index">
            <li v-for="(list, index) in item.list" :key="index">
              <h6>{{ list.tit }}</h6>
              <p>{{ list.text }}</p>
            </li>
          </ul>
        </div>

        <div class="serviceListyi" v-if="dataId == 6">
          <ul v-for="(item, index) in housekeeperyi.list" :key="index">
            <li v-for="(list, index) in item.list" :key="index">
              <h6>{{ list.tit }}</h6>
              <p>{{ list.text }}</p>
            </li>
          </ul>
        </div>

        <div class="serviceLister" v-if="dataId == 7">
          <ul v-for="(item, index) in housekeeperer.list" :key="index">
            <li v-for="(list, index) in item.list" :key="index">
              <h6>{{ list.tit }}</h6>
              <p>{{ list.text }}</p>
            </li>
          </ul>
        </div>

        <img v-if="dataId == 1 || dataId == 4" src="./img/list/process.png" />
        <img v-if="dataId == 5" src="./img/list/epidemic.png" />
        <img v-else-if="dataId == 6" src="./img/list/frame.png" />
        <img v-else-if="dataId == 7" src="./img/list/labourservicesBJ.png" />
        <img
          v-else-if="dataId == 2 || dataId == 3"
          src="./img/list/process-green.png"
        />
        <p v-if="dataId != 5 && dataId != 6 && dataId != 7">
          下载大救星APP或进入大救星小程序，无需记录电话，点击“一键救援”即可求救。
        </p>
      </div>
      <h2 v-if="dataId != 5 && dataId != 6 && dataId != 7">
        <span>—</span>注意事项<span>—</span>
      </h2>
      <div
        v-if="dataId != 5 && dataId != 6 && dataId != 7"
        :class="{ matter: dataId, matterGreen: dataId == 2 || dataId == 3 }"
      >
        <div class="list">
          <div class="th">
            <em>01</em>
            <p>发生下列任一种情形的，将不适用本服务</p>
          </div>
          <div class="table">
            <div>
              <p v-for="(item, index) in indexOne" :key="index">
                <img src="./img/list/list-icon.png" />{{ item.name }}
              </p>
            </div>
            <div>
              <p v-for="(item, index) in indexTwo" :key="index">
                <img src="./img/list/list-icon.png" />{{ item.name }}
              </p>
            </div>
          </div>
          <div class="th">
            <em>02</em>
            <p>发生下列任一种情形的，大救星将不提供</p>
            <p>会员紧急医疗转运或安排医疗送返服务</p>
          </div>
          <div class="table">
            <div>
              <p><img src="./img/list/list-icon.png" />未获得医疗授权</p>
              <p>
                <img
                  src="./img/list/list-icon.png"
                />当地医生可以治疗且不妨碍继续旅行的一般性受伤，如扭伤、轻微骨折或不妨碍旅行的其他情况
              </p>
            </div>
            <div>
              <p>
                <img src="./img/list/list-icon.png" />28周（含）以上的怀孕后期
              </p>
              <p>
                <img
                  src="./img/list/list-icon.png"
                />精神或神经性不适（已入院后发生的除外）
              </p>
            </div>
          </div>
          <div class="th">
            <em>03</em>
            <p>下列情形的，大救星将不承担任何责任</p>
          </div>
          <div class="table">
            <div style="width: 100%">
              <p>
                <img
                  src="./img/list/list-icon.png"
                />虽然紧急援助服务范围遍及全球，运送响应时间与事件发生地有直接关系。对于因罢工或其它无法控制的原因（包括但不限于天气情况、有无机场、飞行条件、有无高压舱、通讯系统、缺少适当的旅行证件或提供服务受到法律或法令的限制或禁止等情形的），导致无法提供服务或服务延迟的，大救星不承担任何责任。
              </p>
            </div>
          </div>
          <div class="th">
            <em>04</em>
            <p>下列情形的，大救星将不承担任何责任</p>
          </div>
          <div class="table">
            <div>
              <p>
                <img
                  src="./img/list/list-icon.png"
                />所有第三方咨询医生和律师等专业人员均为独立的合同方，不受大救星控制。对于其专业人员向会员提供服务所导致的任何执业过失，大救星不承担任何责任。
              </p>
            </div>
          </div>
        </div>
      </div>
      <h2 v-if="dataId != 5 && dataId != 6 && dataId != 7">
        <span>—</span>退改规则<span>—</span>
      </h2>
      <div class="rule" v-if="dataId != 5 && dataId != 6 && dataId != 7">
        <h3>自生效之日起救援服务即不可退单及修改信息。</h3>
        <p>
          注意：本产品所有的页面文字描述为部分展示，具体救援服务详情及保险保障方案等信息以购买成功后生成的凭证及保单为准，大救星保留在法律规定范围内的解释权利。
        </p>
      </div>
    </div>
    <div v-if="dataId == 5 || dataId == 6 || dataId == 7">
      <div class="Epidemicbackground" v-if="dataId == 5">
        <h2 style="text-align: center; padding-top: 40px">
          <span>—</span>所需信息<span>—</span>
        </h2>
        <div style="margin 0 auto;padding: 3vw 22vw;">
          <img src="./img/list/becareful.png" />
        </div>

        <h2 style="text-align: center"><span>—</span>注意事项<span>—</span></h2>
        <div style="margin 0 auto;padding: 1vw 20vw;">
          <div class="text">
            全球新冠肺炎第三国中转救援服务清单所有服务须依据以下条款，该服务自生效之日起有效期为7天。服务适用于境外（含港澳台），所有服务由江泰救援大救星安排，不接受来自于用户的报销请求。
          </div>
        </div>

        <div style="padding: 1vw 20vw">
          <ul
            style="margin-bottom: 1vw"
            v-for="(item, index) in titlist"
            :key="index"
          >
            <li style="width: 100%">
              <!-- <img style="width: 2.5vw; height: 2.5vw" :src="'./img/list/tit-'+item.id+'.png'"/> -->
              <img style="width: 2.5vw; height: 2.5vw"   :src='"./img/list/tit-" + item.id + ".png"'>
              
              <span
                style="
                  width: 90%;
                  text-align: left;
                  float: right;
                  color: #666666;
                  padding-top: 0.3vw;
                "
                >{{ item.text }}
                <div style="padding-top: 1vw">
                  <div
                    v-if="item.list"
                    v-for="(itme, ind) in item.list"
                    :key="ind"
                    style="margin-top: 0.5vw; color: #666666;height: 1.5vw;"
                  >
                    <img src="./img/list/yellow.png" />
                    {{ itme.name }}
                  </div>
                </div>
              </span>
            </li>
          </ul>
          <div>
            <div class="qitaclass">其他说明：</div>
            <!-- <img src="./img/list/qita.png"> -->
          </div>
          <div style="color: #666666; margin-top: 2vw">
            虽然紧急援助服务范围遍及全球，运送响应时间与事件发生地有直接关系。对于因罢工或其它无法控制的原因（包括但不限于天气情况、有无机场、飞行条件、有无高压舱或负压舱、通讯系统、缺少适当的旅行证件或提供服务受到法律或法令的限制或禁止等情形的），导致无法提供服务或服务延迟的，大救星不承担任何责任。
          </div>
        </div>
      </div>
      <div class="Epidemicbackground6" v-if="dataId == 6">
        <h2 style="text-align: center; padding-top: 40px">
          <span>—</span>所需信息<span>—</span>
        </h2>
        <div style="margin 0 auto;padding: 3vw 22vw;">
          <img src="./img/list/bgday.png" />
        </div>
        <h2 style="text-align: center"><span>—</span>注意事项<span>—</span></h2>
        <div style="margin 0 auto;padding: 1vw 20vw;">
          <div class="text">
           境内一日游救援服务清单所有服务须依据以下条款，该服务自生效之日起有效期为7天。服务适用于境外（含港澳台），所有服务由江泰救援大救星安排，不接受来自于用户的报销请求。
          </div>
        </div>
        <div style="padding: 1vw 20vw">
          <ul
            style="margin-bottom: 1vw"
            v-for="(item, index) in titlist2"
            :key="index"
          >
            <li style="width: 100%">
              <!-- <img  style="width: 2.5vw; height: 2.5vw" :src="'./img/list/daytit-' + item.id + '.png'" -->
               <img style="width: 2.5vw; height: 2.5vw"   :src='"./img/list/daytit-" + item.id + ".png"'>
              <!-- /> -->
              <span
                style="
                  width: 90%;
                  text-align: left;
                  float: right;
                  color: #666666;
                  padding-top: 0.3vw;
                "
                >{{ item.text }}
                <div style="padding-top: 1vw">
                  <div
                    v-if="item.list"
                    v-for="(itme, ind) in item.list"
                    :key="ind"
                    style="margin-top: 0.5vw; color: #666666;height: 1.5vw;"
                  >
                    <img src="./img/list/yellow.png" />
                    {{ itme.name }}
                  </div>
                </div>
              </span>
            </li>
          </ul>
          <div>
            <div :class="{ qitaclass: dataId == 5, dayqitaclass: dataId == 6 }">
              其他说明：
            </div>
            <!-- <img src="./img/list/qita.png"> -->
          </div>
          <div style="color: #666666; margin-top: 2vw">
            虽然紧急援助服务范围遍及全球，运送响应时间与事件发生地有直接关系。对于因罢工或其它无法控制的原因（包括但不限于天气情况、有无机场、飞行条件、有无高压舱或负压舱、通讯系统、缺少适当的旅行证件或提供服务受到法律或法令的限制或禁止等情形的），导致无法提供服务或服务延迟的，大救星不承担任何责任。
          </div>
        </div>
      </div>
      <div class="Epidemicbackground7" v-if="dataId == 7">
        <h2 style="text-align: center; padding-top: 40px">
          <span>—</span>所需信息<span>—</span>
        </h2>
        <div style="margin 0 auto;padding: 3vw 22vw;">
          <img src="./img/list/technological.png" />
        </div>
        <h2 style="text-align: center"><span>—</span>注意事项<span>—</span></h2>
        <div style="margin 0 auto;padding: 1vw 20vw;">
          <div class="text">
            全球新冠肺炎境外劳务救援服务救援服务清单所有服务须依据以下条款，该服务自生效之日起有效期为7天。服务适用于境外（含港澳台），所有服务由江泰救援大救星安排，不接受来自于用户的报销请求。
          </div>
        </div>
        <div style="padding: 1vw 20vw">
          <ul
            style="margin-bottom: 1vw"
            v-for="(item, index) in titlist1"
            :key="index"
          >
            <li style="width: 100%">
              <!-- <img style="width: 2.5vw; height: 2.5vw" :src="'./img/list/yellow' + item.id + '.png'"/> -->
                <img style="width: 2.5vw; height: 2.5vw"   :src='"./img/list/yellow" + item.id + ".png"'>
              <span
                style="
                  width: 90%;
                  text-align: left;
                  float: right;
                  color: #666666;
                  padding-top: 0.3vw;
                "
                >{{ item.text }}
                <div style="padding-top: 1vw">
                  <div
                    v-if="item.list"
                    v-for="(itme, ind) in item.list"
                    :key="ind"
                    style="margin-top: 0.5vw; color: #666666;height: 1.5vw;"
                  >
                    <img src="./img/list/yellow.png" />
                    {{ itme.name }}
                  </div>
                </div>
              </span>
            </li>
          </ul>
          <div>
            <div
              :class="{
                qitaclass: dataId == 5,
                dayqitaclass: dataId == 6,
                yaqitaclass: dataId == 7,
              }"
            >
              其他说明：
            </div>
            <!-- <img src="./img/list/qita.png"> -->
          </div>
          <div style="color: #666666; margin-top: 2vw">
            虽然紧急援助服务范围遍及全球，运送响应时间与事件发生地有直接关系。对于因罢工或其它无法控制的原因（包括但不限于天气情况、有无机场、飞行条件、有无高压舱或负压舱、通讯系统、缺少适当的旅行证件或提供服务受到法律或法令的限制或禁止等情形的），导致无法提供服务或服务延迟的，大救星不承担任何责任。
          </div>
        </div>
      </div>
      <!-- <h2>激活方法</h2>
    <div :class="{'activation':dataId,'activationGreen':dataId == 2|| dataId == 3}">
      <ul>
        <li>查看客服消息</li>
        <li>点击激活链接</li>
        <li>填写个人信息</li>
        <li>如期生效</li>
      </ul>
    </div> -->
      <h2 style="text-align: center"><span>—</span>退改规则<span>—</span></h2>
      <div class="rule">
        <h3>自生效之日起救援服务即不可退单及修改信息。</h3>
        <p style="text-align: center">
          注意：本产品所有的页面文字描述为部分展示，具体救援服务详情及保险保障方案等信息以购买成功后生成的凭证及保单为准，大救星保留在法律规定范围内的解释权利。
        </p>
      </div>
    </div>
  </div>
</template>
<script >
export default {
  props: ["id"],
  
  data() {
     
    return {
     
      titlist: [
        {
          id: 1,
          text:
            "本清单每人限投一份，多投无效，用户年龄范围限18至65周岁；不承担外籍人员在本国籍国家期间发生的保险及救援责任；",
        },
        {
          id: 2,
          text:
            "用户需持出发国登机前48小时内核酸检测及血清抗体检测阴性证明，即双阴证明，且大救星不承担被保险人在出发国的相关意外及医疗（含新冠肺炎COVID-19）责任；",
        },
        {
          id: 3,
          text:
            "在中转国家确诊新冠肺炎（COVID-19），需提交中国或中转国家当地大使馆指定的检测机构的诊断结果。",
        },
        {
          id: 4,
          text:
            "如用户在出发国登机前48小时内的核酸检测及抗体检测均为阴性，但在中转国的检测其中一项或两项呈阳性且需在境外医疗机构进行必要治疗的，大救星就其实际支出的必要且合理的医疗费用超过人民币300元部分按100%的比例给付医疗保险金，最高给付金额以合同上载明的相应的限额为限。",
        },
          {
          id: 5,
          text:
            "用户在中转过程中确诊新冠肺炎导致后续回国行程中断且回国机票不能继续使用的情况下，大救星承担用户康复后一张单程经济舱回到中国的机票费用，方案一，最高限额为2万元人民币。方案二，最高限额为3万元人民币。",
        },
        {
          id: 6,
          text: "投保本清单时用户已置身于中华人民共和国境外；",
        },
        {
          id: 7,
          text: "发生下列任一种情形的，大救星将不提供全球用户的救援服务：",
          list: [
            {
              name: "未获得医疗授权；",
            },
            {
              name:
                "当地医生可以治疗且不妨碍继续下一行程的一般性受伤，如扭伤、轻微骨折或感染新冠在酒店进行隔离；",
            },
            {
              name: "28周（含）以上的怀孕后期；",
            },
            {
              name: "违反中国及第三方中转国的新冠肺炎防控管理政策。",
            },
          ],
        },
      ],
      titlist1: [
        {
          id: 1,
          text:
            "本清单每人限投一份，多投无效，用户年龄范围限18至65周岁；不承担用户在本国籍国家期间发生的保险及救援责任；",
        },

        {
          id: 2,
          text: "发生下列任一种情形的，大救星将不提供全球用户的救援服务：",
          list: [
            {
              name: "用户在被转移或需被转移至另一个具有相似医疗水平的医疗场所;",
            },
            {
              name: "处于权益等待期内；",
            },
            {
              name: "除外新冠肺炎以外的其它疾病及意外伤害；",
            },
            {
              name: "违反中国及用户所在国的新冠肺炎防控管理政策；",
            },
            {
              name: "用户非初次罹患新冠肺炎",
            },
          ],
        },
      ],
      titlist2: [
        {
          id: 1,
          text:
            "请妥善保存清单凭证，申请服务项目及相关内容时需提供凭证和当天入场记录（包括但不限于门票、购票记录及视频等）用于服务申请及保险索赔；",
        },

        {
          id: 2,
          text: "本清单每人限投一份，多投无效，用户年龄范围限定在80周岁以下。",
        },
        {
          id: 3,
          text:
            "本清单服务时限：自用户持门票和清单凭证进入参观场所或游（娱）乐场所时起至离开该场所界定的范围时止。",
        },
        {
          id: 4,
          text: "清单凭证私自涂改或未加盖江泰救援服务有限公司印章一律无效。",
        },
        {
          id: 5,
          text: "服务申请或出险报案电话：010-83423665",
        },
        {
          id: 6,
          text:
            "本服务清单中意外死亡、残疾及意外医疗费用，是由江泰救援服务有限公司免费赠送购买本服务清单的用户，具体赔偿责任由相应保险公司承担，保险赔偿处理以江泰救援服务有限公司所投保的保险合同及具体条款约定内容为准",
        },
        {
          id: 7,
          text:
            "特别提示：用户下列行为导致的意外伤害事故或突发急性病，保险公司不承担相应的责任，包括但不限于：",
          list: [
            {
              name:
                "用户自致伤害或自杀，但用户自杀时为无民事行为能力人的除外；",
            },
            {
              name: "因用户挑衅或故意行为而导致的打斗、被袭击或被谋杀；",
            },
            {
              name: "用户妊娠、流产、分娩；",
            },
            {
              name: "被保险人未遵医嘱，私自服用、涂用、注射药物；",
            },
            {
              name: "核爆炸、核辐射或核污染、恐怖袭击用户犯罪或拒捕；",
            },
            {
              name: "用户参加职业或半职业体育运动；",
            },
            {
              name: "战争、军事行动、暴动或武装叛乱期间；",
            },
            {
              name: "用户醉酒或受毒品、管制药物的影响期间；",
            },
            {
              name:
                "用户酒后驾车、无有效驾驶证驾驶或驾驶无有效行驶证的机动车期间；",
            },
            {
              name:
                "既往症及其并发症、精神病、性传播疾病、感染艾滋病病毒或患艾滋病、遗传性疾病、先天性疾病或缺陷、先天性畸形；",
            },
            {
              name: "药物过敏或其他医疗行为导致的伤害；",
            },
            {
              name: "被保险人的故意行为；",
            },
          ],
        },
        {
          id: 8,
          text: "发生下列任一种情形的，将不适用本服务：",
          list: [
            {
              name: "以治疗为特定目的而进行的旅行；",
            },
            {
              name: "因参与非法活动而遭受的伤害；",
            },
            {
              name: "从事违法行为；",
            },
            {
              name: "自杀未遂；",
            },
            {
              name: "使用毒品（但医生开具的处方除外）；",
            },
            {
              name: "用户参加职业或半职业体育运动；",
            },
            {
              name: "战争、军事行动、暴动或武装叛乱期间；",
            },
            {
              name: "用户醉酒或受毒品、管制药物的影响期间；",
            },
            {
              name:
                "用户酒后驾车、无有效驾驶证驾驶或驾驶无有效行驶证的机动车期间；",
            },
            {
              name:
                "既往症及其并发症、精神病、性传播疾病、感染艾滋病病毒或患艾滋病、遗传性疾病、先天性疾病或缺陷、先天性畸形；",
            },
            {
              name: "药物过敏或其他医疗行为导致的伤害；",
            },
            {
              name: "被保险人的故意行为；",
            },
          ],
        },
        
        {
          id: 9,
          text:
            "发生下列任一种情形的，大救星将不提供紧急医疗转运或安排医疗送返服务：",
          list: [
            {
              name: "未获得医疗授权；",
            },
            {
              name:
                "当地医生可以治疗且不妨碍继续旅行的一般性受伤，如扭伤、轻微骨折或不妨碍旅行的其他情况；",
            },
            {
              name: "从事违法行为；",
            },
            {
              name: "自杀未遂；",
            },
            {
              name: "28周（含）以上的怀孕后期；",
            },
            {
              name: "精神或神经性不适（已入院后发生的除外）； ",
            },
          ],
        },
      ],
      housekeeper: {
        name: "3项保险权益",

        list: [
          {
            list: [
              {
                tit: "第一项：",
                text: "意外伤害身故和残疾",
              },
              {
                tit: "第二项：",
                text: "因感染新冠肺炎导致的身故、伤残",
              },
            ],
          },
        ],
      },

      housekeeperyi: {
        name: "3项保险权益",

        list: [
          {
            list: [
              {
                tit: "第一项：",
                text: "拨打24小时全球救援服务热线： 8610-83423665。",
              },
              {
                tit: "第二项：",
                text: "使用大救星微信小程序的一键救援网络呼救：",
              },
            ],
          },
        ],
      },
      housekeeperer: {
        name: "3项保险权益",

        list: [
          {
            list: [
              {
                tit: "第一项：",
                text: "拨打24小时全球救援服务热线： 8610-83423665。",
              },
              {
                tit: "第二项：",
                text: "使用大救星微信小程序的一键救援网络呼救：",
              },
            ],
          },
        ],
      },
      dataId: this.id,
      indexOne: [
        {
          id: 1,
          name: "以治疗为特定目的而进行的旅行",
        },
        {
          id: 2,
          name: "从事违法行为",
        },
        {
          id: 3,
          name: "使用毒品（但医生开具的处方除外）",
        },
        {
          id: 4,
          name: "会员在被转移或需被转移至另一个具有相似医疗水平的医疗场所",
        },
      ],
      indexTwo: [
        {
          id: 1,
          name: "因参与战争或叛乱行为而遭受的伤害",
        },
        {
          id: 2,
          name: "会员未持有有效护照及/或有效的工作签证",
        },
        {
          id: 3,
          name: "自杀未遂",
        },
      ],
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      if (this.dataId == 2) {
        this.indexOne = [
          {
            id: 1,
            name: "以治疗为特定目的而进行的旅行",
          },
          {
            id: 2,
            name: "从事违法行为",
          },
          {
            id: 3,
            name: "使用毒品（但医生开具的处方除外）",
          },
          {
            id: 4,
            name: "会员在被转移或需被转移至另一个具有相似医疗水平的医疗场所",
          },
          {
            id: 5,
            name: "留学生未持有有效护照及/或有效的学生签证",
          },
        ];
        this.indexTwo = [
          {
            id: 1,
            name: "因参与战争或叛乱行为而遭受的伤害",
          },
          {
            id: 2,
            name: "自杀未遂",
          },
          {
            id: 3,
            name: "超过就读期间（一学期或一学年）的旅行",
          },
          {
            id: 3,
            name: "留学生身处中国境内",
          },
        ];
      } else if (this.dataId == 3) {
        this.indexOne = [
          {
            id: 1,
            name: "以治疗为特定目的而进行的旅行",
          },
          {
            id: 2,
            name: "从事违法行为",
          },
          {
            id: 3,
            name: "使用毒品（但医生开具的处方除外）",
          },
          {
            id: 4,
            name: "会员在被转移或需被转移至另一个具有相似医疗水平的医疗场所",
          },
        ];
        this.indexTwo = [
          {
            id: 1,
            name: "因参与战争或叛乱行为而遭受的伤害",
          },
          {
            id: 2,
            name: "自杀未遂",
          },
        ];
      } else {
        this.indexOne = [
          {
            id: 1,
            name: "以治疗为特定目的而进行的旅行",
          },
          {
            id: 2,
            name: "从事违法行为",
          },
          {
            id: 3,
            name: "使用毒品（但医生开具的处方除外）",
          },
          {
            id: 4,
            name: "会员在被转移或需被转移至另一个具有相似医疗水平的医疗场所",
          },
        ];
        this.indexTwo = [
          {
            id: 1,
            name: "因参与战争或叛乱行为而遭受的伤害",
          },
          {
            id: 2,
            name: "会员未持有有效护照及/或有效的工作签证",
          },
          {
            id: 3,
            name: "自杀未遂",
          },
        ];
      }
    },
    sonFun(param) {
      this.dataId = param;
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
em,
i {
  font-style: normal;
}
.qitaclass {
  width: 18%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  color: #ffffff;
  background: url("./img/list/qita.png") no-repeat;
  background-size: cover;
  margin-top: 1vw;
}
.dayqitaclass {
  width: 18%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  color: #ffffff;
  background: url("./img/list/dayother.png") no-repeat;
  background-size: cover;
  margin-top: 1vw;
}
.yaqitaclass {
  width: 18%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  color: #ffffff;
  background: url("./img/list/yatitbg.png") no-repeat;
  background-size: cover;
  margin-top: 1vw;
}
.careful {
  padding: 0 17vw;
  /*background: url('./img/list/careful-bg.png') no-repeat bottom;*/
}
.careful h2 {
  color: rgba(51, 51, 51, 1);
  font-size: 1.6vw;
  margin: 2.5vw 0;
  text-align: center;
  /*padding-bottom:2vw; 
    border-bottom: 1px solid #D8D8D8;*/
}
.careful h2 span {
  font-weight: normal;
  margin: 0 1.5vw;
  color: #000;
}
.process {
  padding: 0 2.5vw;
  margin-bottom: 3vw;
}
.process img {
  width: 100%;
}
.process p {
  margin-top: 1vw;
  font-size: 1.1vw;
  color: #666;
  text-align: center;
}
/*.matter{
    padding-top: 1vw;
  }*/
.th {
  display: table-cell;
  height: 5vw;
  vertical-align: middle;
  position: relative;
  padding-left: 8vw;
  margin-top: 2vw;
}
.th p {
  color: #1587fd;
  font-size: 1.3vw;
  font-weight: bold;
}
.th em {
  position: absolute;
  left: 0;
  top: 1.25vw;
  background: url("./img/list/icon-bg.png") no-repeat bottom;
  background-size: 100% 100%;
  width: 7.5vw;
  height: 2.5vw;
  line-height: 2.5vw;
  color: #fff;
  font-size: 1.5vw;
  text-align: center;
}
.matterGreen .th em {
  background: url("./img/list/icon-bg-green.png") no-repeat bottom;
  background-size: 100% 100%;
}
.matterGreen .th p {
  color: #03b27b;
}
.table {
  width: 100%;
  margin-top: 1vw;
}
.table div {
  width: 45vw;
  padding: 0 2vw;
  display: table-cell;
  vertical-align: top;
}
.table p {
  position: relative;
  padding-left: 2.5vw;
  color: #666;
  font-size: 1.1vw;
  margin-right: 4vw;
  margin-bottom: 1vw;
  line-height: 1.8vw;
}
.table p:last-child {
  margin-right: 0;
}
.table p img {
  position: absolute;
  left: 0;
  top: 0.5vw;
  width: 0.7vw;
}
.activation {
  width: 100%;
  background: url("./img/list/activation-bg.png") no-repeat bottom;
  background-size: 100% 100%;
  height: 2.5vw;
  margin-top: 2.5vw;
}
.activationGreen {
  background: url("./img/list/activation-bg-green.png") no-repeat bottom;
  background-size: 100% 100%;
}
ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  text-align: center;
}
.activation li {
  width: 40%;
  text-align: center;
  line-height: 2.5vw;
  color: #fff;
  font-size: 1.1vw;
  font-weight: bold;
}
.rule h3 {
  margin: 2.5vw 0 1vw;
  font-size: 1.5vw;
  font-weight: normal;
  color: #666;
  text-align: center;
}
.rule p {
  color: #ff8d3a;
  line-height: 2.5vw;
  font-size: 1vw;
  padding-bottom: 3.5vw;
}
.serviceList {
  margin-bottom: 1vw;
}

.serviceList li {
  background: url("./img/list/list-bg-violet.png") no-repeat bottom;
  background-size: 100% 100%;
  position: relative;
}
.serviceList li h6 {
  position: absolute;
  color: #fff;
  font-size: 1.1vw;
  left: 0.5vw;
  top: 1.8vw;
}
.serviceList li p {
  padding: 0 1.5vw 0 10vw;
  height: 6vw;
  font-size: 1vw;
  color: #519dfa;
  display: table-cell;
  vertical-align: middle;
  text-align: left;
}

.serviceListyi {
  margin-bottom: 1vw;
}

.serviceListyi li {
  background: url("./img/list/bg-bord.png") no-repeat bottom;
  background-size: 100% 100%;
  position: relative;
}
.serviceListyi li h6 {
  position: absolute;
  color: #fff;
  font-size: 1.1vw;
  left: 0.5vw;
  top: 1.8vw;
}
.serviceListyi li p {
  padding: 0 1.5vw 0 10vw;
  height: 6vw;
  font-size: 1vw;
  color: #0fabc0;
  display: table-cell;
  vertical-align: middle;
  text-align: left;
}

.serviceLister {
  margin-bottom: 1vw;
}

.serviceLister li {
  background: url("./img/list/bgye.png") no-repeat bottom;
  background-size: 100% 100%;
  position: relative;
}
.serviceLister li h6 {
  position: absolute;
  color: #fff;
  font-size: 1.1vw;
  left: 0.5vw;
  top: 1.8vw;
}
.serviceLister li p {
  padding: 0 1.5vw 0 10vw;
  height: 6vw;
  font-size: 1vw;
  color: #9d8953;
  display: table-cell;
  vertical-align: middle;
  text-align: left;
}

.Epidemicbackground {
  background: url("./img/list/Purplebackground.png");
  background-repeat: no-repeat;
  background-size: cover;
  // background-size: auto 100%;
  // padding: 0px 6vw;
  padding-bottom: 50px;
}
.Epidemicbackground .text {
  background-color: #fbf6e4;
  color: #f27132;
  padding: 1vw;
  border: 1px dashed #ffc917;
  border-radius: 10px;
  margin-bottom: 2vw;
}

.Epidemicbackground6 {
  background: url("./img/list/bgday1.png");
  background-repeat: no-repeat;
  background-size: cover;
  // background-size: auto 100%;
  // padding: 0px 6vw;
  padding-bottom: 50px;
}
.Epidemicbackground6 .text {
  background-color: #fbf6e4;
  color: #f27132;
  padding: 1vw;
  border: 1px dashed #ffc917;
  border-radius: 10px;
  margin-bottom: 2vw;
}
.Epidemicbackground7 {
  background: url("./img/list/EPID7.png");
  background-repeat: no-repeat;
  background-size: cover;
  // background-size: auto 100%;
  // padding: 0px 6vw;
  padding-bottom: 50px;
}
.Epidemicbackground7 .text {
  background-color: #fbf6e4;
  color: #f27132;
  padding: 1vw;
  border: 1px dashed #ffc917;
  border-radius: 10px;
  margin-bottom: 2vw;
}
</style>


// WEBPACK FOOTER //
// src/views/rescuelist/careful.vue